/*
 *  Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 *  All information herein, source code below as well as the Morpheus system itself and all related
 *  software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 *  Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 *  is prohibited.
 */

import Vue from 'vue'
import { MutationTree } from 'vuex'
import { GlobalState } from './types'

export const mutations: MutationTree<GlobalState> = {
  setLoading (state, status) {
    state.loading = status
  },
  addNotification (state, { text, type }) {
    const id = new Date().getTime()
    state.notifications.push({
      text: text,
      type: type,
      id: id
    })
  },
  deleteNotification (state, id) {
    const notificationIndex = state.notifications.findIndex((notification) => notification.id === id)
    Vue.delete(state.notifications, notificationIndex)
  }
}
